<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/TDC/Evaluation.vue'

    export default {
        components: {
            Grid,
        }
    }
</script>
